export const trackingEvents = {
  PAGE: {
    VIEWED: 'employer_blocks.page.viewed',
  },
  EDIT: {
    CLICKED: 'employer_blocks.edit.clicked',
  },
}
